import * as React from 'react';
import { cn } from '@/core/lib/utils';

export interface InlineTextareaProps extends React.ComponentProps<'textarea'> {
  containerClassName?: string;
}

/**
 * Textarea estilizado para uso inline sin react-hook-form.
 *
 * Aplica las clases de diseño del sistema (fondo transparente, tipografía,
 * placeholder) para mantener consistencia visual sin depender de un form field
 * con Controller.
 *
 * @example
 * <InlineTextarea
 *   rows={2}
 *   placeholder="Escribe algo..."
 *   className="min-h-[3rem]"
 * />
 */
export const InlineTextarea = React.forwardRef<HTMLTextAreaElement, InlineTextareaProps>(
  ({ className, containerClassName, ...props }, ref) => {
    return (
      <div className={cn('relative w-full', containerClassName)}>
        <textarea
          ref={ref}
          {...props}
          className={cn(
            'w-full resize-none bg-transparent text-sm font-medium leading-snug outline-none',
            'placeholder:font-normal placeholder:text-muted-foreground/60',
            className,
          )}
        />
      </div>
    );
  },
);
InlineTextarea.displayName = 'InlineTextarea';
